import {
  Component,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { CloudflareChallengeService } from './cloudflare-challenge.service';
import { Subscription } from 'rxjs';
import {environment} from "../../../environments/environment";
import { CommonModule } from '@angular/common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const turnstile: any;

@Component({
  selector: 'app-cloudflare-turnstile-modal',
  imports: [CommonModule],
  template: `
    <div *ngIf="isVisible" class="challenge-overlay">
      <div class="challenge-box">
        <div #turnstileContainer></div>
      </div>
    </div>
  `,
  styles: [`
    .challenge-overlay {
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.2);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .challenge-box {
      padding: 2rem;
      border-radius: 12px;
    }
  `]
})
export class CloudflareTurnstileModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('turnstileContainer', { static: false }) containerRef!: ElementRef;

  isVisible = false;
  private stateSub?: Subscription;

  constructor(
    private challengeService: CloudflareChallengeService,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.stateSub = this.challengeService.isChallengeActive$.subscribe((active) => {
      if (active) {
        this.isVisible = true;
        this.cdr.detectChanges(); // force DOM update
        setTimeout(() => this.renderTurnstile(), 0);
      } else {
        this.isVisible = false;
        this.cdr.detectChanges();
      }
    });
  }

  private renderTurnstile(): void {
    const container = this.containerRef?.nativeElement;
    if (!container) {
      console.error('[Turnstile] container not found');
      return;
    }

    container.innerHTML = '';
    turnstile.render(container, {
      sitekey: environment.cloudflare.turnstileKey,
      callback: (token: string) => {
        this.challengeService.resolveWithToken(token);
      }
    });
  }

  ngOnDestroy(): void {
    this.stateSub?.unsubscribe();
  }
}
